const defaultForm = {
    id: null,
    active: true,
    first_name: '',
    last_name: '',
    email: '',
    sex: 'M',
    timezone: 'America/Montreal',
    locale: 'fr-CA',

    post: null,
    role: {},
    role_id: null,
    team: null,
    supplier: null,
    divisions: [],
    profilePicturePath: '',
    profile_picture: '',
    user_phones: [],
    suppliers: [],
    director_inactive: null,
    director_inactive_children: {},
    inbound_cc_users: [],
    inbound_cc_users_children: {},
    groups: [],
    reminder_preferences: [],
    default_dashboard: null,

    password: '',
    password_confirmation: '',
    block_lead_info: true,
    hide_in_user_select: false,
    no_reassignation_notification: false,
    next_step: true,
    next_step_mandatory: false,
    mass_mailing: true,
    campaign: false,
    niotext: false,
    mail_inbox: false,
    restrict_interdealer_leads: false,
    allow_email_template_edition: false,
    use_dealer_name_as_sender: false,

    appt_report: false,
    appt_sms: false,
    appt_email: false,

    sale_report: false,
    sale_sms: false,
    sale_email: false,

    freeze_financial_data: false,
    hide_fi_profits: false,
    allow_import_access: false,
    allow_export_access: false,
    allow_event_creation: false,
    end_contract_required: false,
    in_turn_edit: false,
    bell_event_option: false,
    can_create_child: false,
    credit: true,
    trade_report: false,
    automation_access: false,
    automation_advanced_access: false,
    director_access_renewal: false,
    has_analytics_access: false,
    analytics_module_access: false,
    api_user: false,

    email_config: {
        access_token: '',
        active: false,
        signature_translations: {},
    },

    module_access: {
        leadxpress: true,
        web_boost: true,
        walk_in: true,
        phone_up: true,
        loyalty: false,
        service: false,
        event: false,
        renewal: false,
        sale_table: false,
        commercial: false,
        activity_report: true,
        web_order: false,
    },

    custom_permissions: {
        delete_lead: false,
        merge_lead: false,
        limit_audio_access: false,
        limit_calendar_task_access: true,
    },

    automation_options: {},

    options: {
        newLeadLoyalty: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            availability: 'user_schedule',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        newLeadLoyaltyDuplicate: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            availability: 'user_schedule',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignLeadDemand: {
            screen: false,
            email: true,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignUser: {
            screen: true,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        taskEventUnassigned: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        taskDeleted: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        alertCommentReply: {
            screen: true,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        commentFollow: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        clientResponse: {
            screen: true,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        lostAlert: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
        },
        invalidAlert: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
        },
        needsAttentionAlert: {
            screen: false,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        declinedLeadDemand: {
            screen: true,
            email: false,
            push: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        leadWaitingInRoom: {
            email: false,
            push: true,
            sms: false,
            lead_status: [],
        },
        missedCall: {
            screen: false,
            sms: false,
            push: false,
            email: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        leadAuto: {
            screen: true,
            sms: false,
            push: false,
            email: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        noDivision: {
            screen: true,
            sms: false,
            push: false,
            email: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        takeOver: {
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        noPhoneAlert: {
            screen: true,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        nextInTurn: {
            screen: true,
            sms: false,
            push: false,
            availability: 'anytime',
        },
        noUserInTurn: {
            screen: true,
            sms: false,
            push: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        eventLeadToReach: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        eventNewAppointment: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        eventNewPhoneAppointment: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        eventConfirmedAppointment: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        eventCanceledAppointment: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        eventBadService: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        serviceMyClientsAppointments: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        serviceMyClientsVehiclePickUp: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        serviceVehiclePickUp: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            availability: 'anytime',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        nioTextIncoming: {
            screen: true,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        renewalAlertEquity: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
        },
        renewalAlertEndLocation: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        renewalAlertEndWarranty: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            lead_status: [],
        },
        renewalAlertExcessMileage: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            lead_status: [],
        },
        inTurnRemove: {
            screen: false,
            sms: false,
            push: false,
            availability: 'anytime',
            lead_status: [],
        },
        stateChanged: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        appointment: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            lead_status: [],
        },
        sale: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        deposit: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        approved: {
            screen: true,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        prepared: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        inspected: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        gas: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        delivered: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        deliveryDate: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        availableDate: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        paperworkDate: {
            screen: false,
            sms: false,
            email: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        untreatedLead: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            availability: 'user_schedule',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        untreatedLeadDuplicate: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            availability: 'user_schedule',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignLeadFollow: {
            screen: false,
            email: false,
            sms: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        newLead: {
            screen: true,
            email: false,
            sms: false,
            push: false,
            availability: 'user_schedule',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        newLeadDuplicate: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            availability: 'user_schedule',
            divisions: [1, 2, 3],
            lead_status: [],
        },
        emailRead: {
            screen: true,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        newNoteOnAssignedLead: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
        },
        newCommunicationOnAssignedLead: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignedLeadUpdated: {
            screen: true,
            email: true,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignedLeadVehicleCreated: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignedLeadVehicleCreatedManager: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignedLeadVehicleUpdated: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        assignedLeadVehicleUpdatedManager: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        taskEventDatesUpdated: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        taskEventStatusUpdated: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        mentions: {
            screen: true,
            email: true,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        returnToMarket: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        feedbackCalculator: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        leadAddedToSalesJourney: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        leadSeparatedFromSalesJourney: {
            screen: false,
            email: false,
            sms: false,
            push: false,
            divisions: [1, 2, 3],
            lead_status: [],
        },
        failureMassEmail: {
            screen: false,
            email: false,
            sms: false,
            push: false,
        },
    },

    default_account_id: null,

    confirmation_timeframe: {
        when: '24_hours_before',
        time: null,
    },
    older_than: null,
    newer_than: null,

    account: {},
    child_accounts: [],
    children: [],
    parent: {},
    parent_user_id: null,
    calculator_value_visible: false,
    bdc_super_access: false,
    service_super_access: false,
    flows: [],
    access_token: '',
    personal_tokens: [],
    last_mobile_heartbeat_at: null,
    abilities: [],
};

export default {
    currentForm: defaultForm,
    defaultForm,
    mfaEnrolled: null,
};
